// NO BOUNCE BUTTON, A , LINK
// ----------------------------------- 

(function (window, document) {

    var execute = function (element) {

        $(element).on('click', '.no-bounce', initBounce);

        function initBounce(event) {

            var timeout = $(event.currentTarget).data('bounce') || 1000;
            $(event.currentTarget).css("pointer-events", "none");
            setTimeout(function () {
                $(event.currentTarget).css("pointer-events", "auto");
                console.log("revert");
            }, timeout);

        };
    };


    /****** EVENTS RAILS READY BY ESTUDIOLIVER *******/

    $(function () {
        execute(document.body);  // ready form document
    });

    $(document).on("modalDialogOverlay.shown.bs.modal modalDialog.shown.bs.modal confirmdialog.shown.bs.modal modal.loadedform", function (e, modal) {
        execute(modal);  // showDialog & confirmDialog & ajaxform
    });



})(window, document);
